import { render, staticRenderFns } from "./PosVatExemptSales.vue?vue&type=template&id=dfda6274&"
import script from "./PosVatExemptSales.vue?vue&type=script&lang=js&"
export * from "./PosVatExemptSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports